const VK_RAW_LAUNCH_PARAMS_KEY = "vk_raw_launch_params";

function hasRequiredVkParams(raw: string): boolean {
  if (!raw) return false;
  const params = new URLSearchParams(raw);
  return params.has("vk_app_id") && params.has("vk_user_id") && params.has("sign");
}

/**
 * Captures the exact launch query before Vue Router can normalize the URL.
 * The returned string is never decoded, encoded, sorted or reconstructed.
 */
export function captureRawVkLaunchParams(): string {
  const search = window.location.search;
  const rawSearch = search.startsWith("?") ? search.slice(1) : search;

  if (hasRequiredVkParams(rawSearch)) {
    sessionStorage.setItem(VK_RAW_LAUNCH_PARAMS_KEY, rawSearch);
    return rawSearch;
  }

  // Hash-based clients may provide the launch query after the first `?`.
  const hash = window.location.hash;
  const rawHash = hash.includes("?") ? hash.slice(hash.indexOf("?") + 1) : hash.replace(/^#/, "");
  if (hasRequiredVkParams(rawHash)) {
    sessionStorage.setItem(VK_RAW_LAUNCH_PARAMS_KEY, rawHash);
    return rawHash;
  }

  return sessionStorage.getItem(VK_RAW_LAUNCH_PARAMS_KEY) || "";
}

export function getRawVkLaunchParams(): string {
  return captureRawVkLaunchParams();
}
